export default {
  NEW_BATCH: 'New Batch'
};
